function ReverseLetters({ input }) {

  return (
    <div className="output2">{input.split('').reverse()}</div>
  )
}

export default ReverseLetters;